var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-t-10"},[_c('b-button',{on:{"click":_vm.handleJoinPublicViewing}},[_vm._v("プレイヤーとして参加せず ゲームを観戦する")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }